import { List } from "@mui/material";
import { ALERT_MESSAGE_TYPE, useTranslation } from "hhn-commons";
import { TransitionGroup } from "react-transition-group";
import EmptyRecordView from "../common/EmptyRecordView";
import GoToTop from "../common/GoToTop";
import ScrollListContainer from "../common/ScrollListContainer";
import { useScrollAnchor } from "../hooks/useScrollAnchor";
import ProgressLoader from "../loader/ProgressLoader";
import { AlertTypeDataProps } from "./AlertMessagesList";
import AlertMessageTypeItem from "./AlertMessageTypeItem";

interface AlertMessage {
  type: ALERT_MESSAGE_TYPE;
  alertTypeData: AlertTypeDataProps[];
  onScroll?: () => Promise<void>;
  isDataLoading?: boolean;
  restTop?: number;
}

const AlertMessageType = ({
  type,
  alertTypeData,
  onScroll,
  isDataLoading,
  restTop = 165,
}: AlertMessage) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });

  const { scrollContainerRef, isShowGoToTopButton, goToTop } = useScrollAnchor({
    items: alertTypeData,
    getItemId: item => item.alertId || item.message?.getMessage().id || "",
    disableScrollCompensation: true,
  });

  return (
    <ScrollListContainer
      ref={scrollContainerRef}
      dataTestId={"alert-message-" + type.toLowerCase()}
      onScrollCallback={onScroll}
      isLoading={isDataLoading}
      restTop={restTop}
    >
      <>
        {isShowGoToTopButton && <GoToTop onClick={goToTop} />}
        {alertTypeData.length > 0 && (
          <List data-testid="alert-list">
            <TransitionGroup>
              {alertTypeData.map((data: AlertTypeDataProps) => {
                return (
                  <AlertMessageTypeItem
                    data={data}
                    key={data.alertId || data.message?.getMessage().id}
                  />
                );
              })}
            </TransitionGroup>
          </List>
        )}
        {!isDataLoading && alertTypeData.length === 0 && <EmptyRecordView />}
        {isDataLoading && (
          <ProgressLoader
            label={tNs("alerts.alertsLoadingMessage")}
            style={{
              height: "auto",
              marginTop: "16px",
            }}
          />
        )}
      </>
    </ScrollListContainer>
  );
};

export default AlertMessageType;
